<template>
  <div style="padding:0 30px 0 60px">
    <div class="title">
      <h2>
        通讯录
        <peixun type="7" style="display:inline-block;margin-left:5px;position:relative;"></peixun>
      </h2>
    </div>
    <div class="serch">
      <el-input
        v-model.trim="serch"
        style="width:200px"
        size="small "
        placeholder="请输入公司简称"
        @keyup.enter.native="getdata"
      ></el-input>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="getdata">搜索</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="clear">清空</div>
      <el-input
        v-model.trim="thirdPerson"
        style="width:200px;margin-left:20px"
        size="small "
        placeholder="协会人员搜索"
        @keyup.enter.native="serchThirdPerson"
      ></el-input>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="serchThirdPerson">搜索</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="thirdPerson = ''">清空</div>
      <!-- <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left:50px" @click="originalList">
        原始list上传
      </div> -->
      <div v-if="isadmin" style="float:right">
        <!-- <div
          class="radish-btn radish-btn-primary radish-btn-small"
          style="margin-left:20px"
          @click="showupload('many')"
        >
          处理后list上传
        </div> -->
        <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left:20px" @click="showUnhandledList">
          list错误处理
        </div>
      </div>
    </div>
    <div class="type">
      <el-select v-model="industry" filterable size="small " placeholder="请选择行业类型" @change="getdata">
        <el-option v-for="item in industries" :key="item" :label="item" :value="item"></el-option>
      </el-select>
    </div>
    <el-alert
      title="上传文件时，请在文件名中时加入年份信息，如：嘉实基金-2018.xlsx。否则无法在List管理中按分类统一查看"
      type="error"
    ></el-alert>
    <el-alert
      title="上传往年list解析时表头：姓名 部门 二级部门 手机 目前职位 座机 地域 邮箱 其他 性别 职能模块 "
      type="warning"
    ></el-alert>
    <el-table :data="tableData" border size="small" :height="listHeight" style="width: 100%">
      <el-table-column v-if="isadmin" prop="操作" label="操作" width="60">
        <template slot-scope="scope">
          <el-button
            icon="el-icon-upload2"
            type="primary"
            size="mini"
            circle
            @click="showupload(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="排名" label="排名" sortable width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.排名 !== '999999'">{{ scope.row.排名 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="简称" label="公司" width="120"></el-table-column>
      <el-table-column prop="系统list" label="系统list" width="120">
        <template slot-scope="scope">
          <span class="alpha-tag" @click="showCompanySuperList(scope.row.简称)">系统list</span>
        </template>
      </el-table-column>
      <el-table-column prop="协会list" label="协会list" width="120">
        <template slot-scope="scope">
          <span class="alpha-tag" @click="showThirdPersonList(scope.row.简称)">协会list</span>
        </template>
      </el-table-column>
      <el-table-column v-for="key in tableHead" :key="key" :prop="key" :label="key">
        <template slot-scope="scope">
          <span
            :class="[scope.row.往年list.includes(key) ? '' : 'info', 'alpha-tag']"
            @click="checkFormerYearsList(scope.row, key)"
            >{{ key }}list</span
          >
          <div style="display:inline-block;padding-left:5px;">
            <el-popover
              v-if="scope.row[key] && scope.row[key].length > 0"
              placement="right"
              width="700"
              trigger="click"
            >
              <FileTable :files="scope.row[key]" :paginate="false" width="600" :show-download="isadmin" height="300" />
              <span slot="reference" class="drawer-link">
                <i class="el-icon-view"></i> {{ scope.row[key] && scope.row[key].length }}
              </span>
            </el-popover>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 批量上传，名字错误的文件展示 -->
    <el-dialog :visible.sync="dialog" :close-on-click-modal="false" width="360px" :modal="false">
      <el-button v-for="name in wrongName" :key="name" size="mini" style="margin:0 10px 10px 0">{{ name }}</el-button>
    </el-dialog>
    <UploadDialog ref="UploadDialog" type="往年list" label="list" :on-success="uploadsuccess" :on-error="uploaderror" />
    <!-- <div class="list-box" v-if="clickCompany||thirdPerson">
      <div class="propject_detail_info_close_btn" @click="closeThirdPersonclickCompany = ''" style="right:20px">
        <i class="el-icon-error"/>
      </div>
    </div> -->
    <thirdPersonLists ref="thirdPersonLists"></thirdPersonLists> <unhandledList ref="unhandledList" />
  </div>
</template>
<script>
import { FileTable } from '../../file'
import thirdPersonLists from './thirdPersonLists'
import unhandledList from './unhandledList'

export default {
  components: { thirdPersonLists, FileTable, unhandledList },
  data() {
    return {
      couldDownload: false,
      serch: '',
      company: '',
      downloadLoading: false,
      industry: '公募基金',
      industries: app.industries || [],
      tableData: [],
      data: [],
      tableHead: ['2020', '2019', '2018', '2017', '2016', '2015', '2014', '2013', '其他'],
      isadmin: false,
      companyToId: {},
      companyNames: [],
      wrongName: [],
      dialog: false,
      uploadType: '',
      formerYearsListType: { cid: '', year: '' },
      listHeight: '100px',
      thirdPerson: '',
    }
  },
  watch: {
    dialog(newValue, oldValue) {
      if (!newValue) {
        this.wrongName = []
        this.$refs.UploadDialog.clean()
      }
    },
  },
  mounted() {
    const thisYear = new Date().getFullYear()
    const years = []
    for (let i = 2013; i <= thisYear; i++) {
      years.push(`${i}`)
    }
    this.years = years
    this.tableHead = ['其他'].concat(years).reverse()
    this.$nextTick(() => {
      this.listHeight = `${window.innerHeight - 295}px`
    })
    this.isadmin = app.user.角色 && (app.user.角色.includes('管理员') || app.user.角色.includes('数据处理'))
    if (Object.keys(this.$route.params).length !== 0) {
      const { company = {}, year } = this.$route.params
      this.serch = company.简称 || ''
      this.showFormerYearsList(company, year)
    }
    else if (Object.keys(this.$route.query).length !== 0) {
      const { cid, companyName, year, depart, radishName, listType } = this.$route.query
      this.serch = companyName || ''
      if (cid && year) {
        app.root.$refs.formerYearsList &&
          app.root.$refs.formerYearsList.open({ cid, year, companyName, depart })
      } else if (radishName){
        this.thirdPerson = radishName
        return this.serchThirdPerson()
      } else if(listType==='thirdPersonList'){
        this.showThirdPersonList(companyName)
      } else if(listType==='superList'){
        this.$nextTick(_=>{
          this.showCompanySuperList(companyName)
        })
      }
    }
    this.getdata()
  },
  methods: {
    hanldeSpecialUser(tableData){
      const specialUsers = ['TerryGao','MiaFu']
      const isAdmin = app.user.角色 && app.user.角色.includes('管理员')
      const account = app.user.account

      if(!isAdmin && !specialUsers.includes(account)){
        const { tableHead } = this
        for(const row of tableData){
          for(const type of tableHead){
            row[type] = row[type].filter(a=>!a.listOption || a.listOption.备注 !== '不要整理')
          }
        }
      }
    },
    serchThirdPerson() {
      this.$refs.thirdPersonLists && this.$refs.thirdPersonLists.serchThirdPerson(this.thirdPerson)
    },
    showCompanySuperList(companyName) {
      app.root.$refs.companySuperList && app.root.$refs.companySuperList.open(companyName)
    },
    showThirdPersonList(companyName) {
      this.$refs.thirdPersonLists && this.$refs.thirdPersonLists.open(companyName)
    },
    async _parsesuccess(file) {
      const result = await window.app.service('file').parseXlsx(file)

      const option = Object.assign({ table: result.sheetsData, fileId: file.md5 }, this.formerYearsListType)
      const res = await app.service('company').insertFormerYearsList(option)
      this.$message(res.msg)
      // const { cid, year } = this.formerYearsListType
      // this.showFormerYearsList({ _id: cid }, year)
    },
    checkFormerYearsList(row, key) {
      // if (!this.isadmin) return
      this.formerYearsListType.cid = row._id
      this.formerYearsListType.year = key
      if (row.往年list.includes(key)) {
        this.showFormerYearsList(row, key)
      } else if (this.isadmin) {
        this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
        this.uploadType = '往年list'
      }
      // else {
      //   this.originalList()
      // }
    },
    showFormerYearsList(row, key) {
      app.root.$refs.formerYearsList &&
        app.root.$refs.formerYearsList.open({ cid: row._id, year: key, companyName: row.简称 })
    },
    originalList() {
      app.root.upload('list')
    },
    init() {
      this.data = JSON.parse(JSON.stringify(this.tableData))
      this.companyToId = {}
      this.companyNames = []
      this.data.forEach(company => {
        this.companyToId[company.简称] = company._id
        this.companyNames.push(company.简称)
      })
    },
    async getdata() {
      const result = await window.app.service('company').getLists({ 行业: this.industry, 公司: this.serch })
      if (result.status === 'success') {
        const tableData = result.data
        this.hanldeSpecialUser(tableData)
        this.tableData = tableData
        this.init()
      }
    },
    clear() {
      this.serch = ''
      this.getdata()
    },
    showupload(val) {
      this.company = val === 'many' ? '' : val
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    showUnhandledList() {
      this.$refs.unhandledList.open()
    },
    async uploadsuccess(responce, file, filelist) {
      if (this.uploadType === '往年list') {
        this._parsesuccess(responce[0])
        this.uploadType = ''
        return
      }

      const option = {
        fileId: responce[0]._id,
        originalname: responce[0].originalname,
        uploader: responce[0].uploader,
        createAt: responce[0].createAt,
        type: 'list',
        src: responce[0].src,
      }
      if (this.company !== '') {
        option.companyId = this.company._id
        this.company = ''
      } else {
        const strArr = option.originalname.split('-')
        const name = strArr[0]
        let isRightName = false
        this.companyNames.forEach(company => {
          if (company === name) {
            isRightName = true
          }
        })
        if (isRightName) {
          option.companyId = this.companyToId[name]
        } else {
          this.wrongName.push(option.originalname)
        }
      }
      if (option.companyId) {
        const result = await window.app.service('company').uploadAtta(option)
        if (result.status !== 200) {
          this.$message.error(result.msg)
        } else {
          const type = this.checkcol(option.originalname)
          this.tableData.map(row => {
            if (row._id === option.companyId) {
              row[type].push(option)
            }
          })
        }
      } else {
        const lastfile = filelist[filelist.length - 1]
        this.dialog = lastfile.name === file.name && this.wrongName.length !== 0
      }
    },
    checkcol(str) {
      let strtype = ''
      const types = this.years
      types.map(type => {
        if (str.includes(type)) strtype = type
      })
      return strtype || '其他'
    },
    async uploaderror(responce) {
      this.$message.error(responce)
    },
    async preview(file) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
    async download(file = {}) {
      if (this.downloadLoading) return
      try {
        let a = document.createElement('a')
        a.style.display = 'none'
        a.download = ''
        const { src, fileId, _id } = file
        if (src) {
          a.href = window.host + src
        } else if (fileId || _id) {
          const res = await window.app.service('file').fetch(_id)
          a.href = window.host + res.src
        }
        this.downloadLoading = true
        a.target = '_blank'
        a.click()
        a = null
        this.downloadLoading = false
      } catch (error) {
        this.$message.error(error.message)
      }
    },
  },
}
</script>
<style>
.serch,
.type {
  margin-bottom: 10px;
}
.alpha-tag {
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  font-size: 12px;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  display: inline-block;
  cursor: pointer;
  color: #1d66b1;
  border: 1px solid rgba(50, 120, 193, 0.2);
  background-color: rgba(26, 125, 226, 0.14);
}
.alpha-tag.info {
  color: #d0d0d0;
  border-color: rgba(167, 167, 167, 0.2);
  background-color: rgba(181, 181, 181, 0.1);
}
.alpha-tag.danger {
  background-color: rgba(245, 108, 108, 0.1);
  border-color: rgba(245, 108, 108, 0.2);
  color: #f56c6c;
}
</style>
<style scoped>
.list-box {
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 30;
  padding-bottom: 10px;
  width: 100vw;
  background-color: #fff;
}
</style>
